import { request } from './request'
// 获取任务列表
export interface GetWebGatewayData {
  limit: number
  page: number
  task_id?: string
  start_time?: string
  end_time?: string
  biz_area?: string
  keyword?: string
  score_level?: number
  result_status?: number
}
export interface TaskListProps {
  //  安全域
  areaName?: string[]
  createTimeEnd?: string
  createTimeStart?: string
  //  任务分组
  groupId?: string
  //  每页几条
  limit?: number
  //  第几页
  page?: number
  //  任务名称/客户端名称
  search?: string
  //  任务状态
  //  TaskResultStatusWaiting: 等待中
  //  TaskResultStatusProcessing: 进行中
  //  TaskResultStatusFinished: 已完成
  //  TaskResultStatusInterrupted: 已中断
  //  TaskResultStatusStopping: 停止中
  taskStatus?: string[]
  //  验证类型
  //  VerificationTypeOnline: 在线验证
  //  VerificationTypeOffline: 离线验证
  verificationType?: string
  [property: string]: any
}
export const getWebGatewayTaskList = (data: GetWebGatewayData) =>
  request('/portal/verify/webGateway/resultList', {
    params: {
      ...data,
    },
  })
export const getBizAreaList = () => request('/portal/verify/webGateway/resultBizAreaList')
// 获取列表数量详情
export interface GetWebDetail {
  portal_id: number
  status: 1 | 2
}
export const getWebDetail = (data: GetWebDetail) =>
  request('/portal/verify/webGateway/taskResultScore', {
    params: {
      ...data,
    },
  })
// 获取模板列表
export interface GetListDetails {
  portal_id: number | string
  name?: any
  limit: number
  page: number
  status: number
}
export const getListDetails = (data: GetListDetails) =>
  request('/portal/verify/webGateway/taskResultTemplateList', {
    params: {
      ...data,
    },
  })
// 获取子模板列表
export interface GetListDetailsElement {
  result_id: string | undefined
  task_id: string
  keyword?: string
  intercept_status: number
  risk_level: string
  attack_type?: string
  template_id?: string
  page: number
  limit: number
  apt_id?: string
  protocol?: string
  confidence_level?: string
  tag_ids?: string[]
}
export const getListDetailsElement = (data: GetListDetailsElement) =>
  request('/portal/verify/webGateway/resultResourceList', {
    method: 'post',
    data,
  })
//  删除列表
export interface DeleteList {
  result_id_list: string[]
}
export const deleteList = (data: DeleteList) =>
  request('/portal/verify/webGateway/batchDeleteResult', {
    method: 'delete',
    data,
  })

//  获取开始时间列表
export interface GetJobResultStartTimeList {
  task_id: number
}
export const getJobResultStartTimeList = (data: GetJobResultStartTimeList) =>
  request('/portal/verify/webGateway/taskResultStartTimeList', {
    params: {
      ...data,
    },
  })
// 获取refs

export const getRefs = () => request('/portal/verify/webGateway/refs')

export interface GenerateReport {
  user_id: string
  result_id: string
  name?: string
}
export const generateReport = (data: GenerateReport) =>
  request('/portal/verify/waf/results/report', {
    method: 'post',
    data,
  })

//停止任务
export const stopTask = data =>
  request('/portal/verify/webGateway/stopTask', {
    method: 'post',
    data,
  })

//任务复测
export const retestTask = data =>
  request('/portal/verify/webGateway/taskReExec', {
    method: 'post',
    data,
  })

// 获取任务详情用例状态列表
export const getTaskDetailUseCaseStatus = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/case_status_list`, {
    params: {
      ...data,
    },
  })

// 任务结果 根据用例状态统计用例数
export const getTaskDetailUseCaseCount = data =>
  request(`/portal/verify/web_gateway/results/${data.resultId}/case_status_count`, {
    params: {
      ...data,
    },
  })

// 获取任务详情
export const getTaskDetail = (id: string) => request(`/portal/verify/web_gateway/task/${id}`)

// 获取任务分组列表
export const getGroupList = data =>
  request(`/portal/verify/web_gateway/tasks/group_list`, { params: data })

// 主任务删除
export const deleteTask = (taskIds: string[]) =>
  request(`/portal/verify/web_gateway/tasks`, { method: 'post', data: { taskIds } })

// 获取任务执行列表
export const getTaskExecList = (id: string, data: TaskListProps) =>
  request(`/portal/verify/web_gateway/tasks/${id}/results`, {
    params: {
      ...data,
    },
  })

// 主任务列表
export const getResultList = (data: TaskListProps) =>
  request('/portal/verify/web_gateway/tasks', {
    params: {
      ...data,
    },
  })

// 获取安全设备列表
export const getSecurityDeviceList = () => request('/portal/verify/web_gateway/tasks/device_list')

// 获取执行主体列表
export const getAgentList = () => request('/portal/verify/web_gateway/tasks/agent_list')

// 关联模板列表
export const getTaskDetailTemplateList = data =>
  request(`/portal/verify/web_gateway/tasks/${data.taskId}/templateList`, { params: data })

// 关联模板用例列表
export const getTaskDetailCaseList = data =>
  request(`/portal/verify/web_gateway/tasks/${data.taskId}/templates/${data.templateId}/caseList`, {
    params: data,
  })

// 关联模板用例攻击类型列表
export const getTaskDetailCaseAttackType = data =>
  request(`/portal/common/attack/attack_type_filter_list`, {
    params: data,
  })
